<template>
    <CModal
        title="Редактирование заказа"
        :show.sync="modal.visible"
        :footer="false"
    >
        <template>
            <div slot="body-wrapper" class="modal-body">
                <CForm v-if="order">
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Статус</CCol>
                        <CCol sm="9">
                            <CSelect
                                inline
                                :value.sync="order.status"
                                :options="statuses"
                                placeholder="Статус..."
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="order.status === 5"
                        form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Доставлен до двери</CCol>
                        <CCol sm="9">
                            <CInputCheckbox :checked.sync="order.delivered_door" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Внешний ID</CCol>
                        <CInput v-model="order.external_id" placeholder="Внешний ID" />
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Башня</CCol>
                        <CCol sm="9">
                            <CSelect
                                inline
                                :value.sync="order.tower"
                                :options="towers"
                                placeholder="Башня..."
                            />
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="order.address"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Адрес</CCol>
                        <CCol v-if="order.address" sm="9">
                            <CRow>
                                <CCol>
                                    <CInput v-model="order.address.street" placeholder="Улица..." />
                                </CCol>
                                <CCol>
                                    <CInput v-model="order.address.building" placeholder="Дом..." />
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow
                        v-if="order.address_details"
                        form
                        class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Подробности адреса</CCol>
                        <CCol v-if="order.address_details" sm="9">
                            <CRow>
                                <CCol>
                                    <CInput v-model="order.address_details.entrance" placeholder="Под." />
                                </CCol>
                                <CCol>
                                    <CInput v-model="order.address_details.floor" placeholder="Эт." />
                                </CCol>
                                <CCol>
                                    <CInput v-model="order.address_details.appartment" placeholder="Кв." />
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Тип доставки</CCol>
                        <CCol sm="9">
                            <CSelect
                                inline
                                :value.sync="order.delivery_type"
                                :options="delivery_types"
                                placeholder="Тип доставки..."
                            />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Доставка как можно скорее</CCol>
                        <CCol sm="9">
                            <CInputCheckbox :checked.sync="order.delivery_now" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Время доставки</CCol>
                        <CCol sm="9">
                            <CInput v-model="order.delivery_time" placeholder="Дата и время в формате YYYY-MM-DD HH:MM:SS" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Время приготовления</CCol>
                        <CCol sm="9">
                            <CInput v-model="order.time_cooking" placeholder="Дата и время в формате YYYY-MM-DD HH:MM:SS" />
                        </CCol>
                    </CRow>
                    <!-- <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Промокод</CCol>
                        <CCol sm="9">
                            
                            <CSelect
                                inline
                                :value.sync="order.promocode"
                                :options="promocodes"
                                placeholder="Промокод..."
                            />
                        </CCol>
                    </CRow> -->
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Комментарий администратора</CCol>
                            <CCol sm="9">
                                <CInput v-model="order.comment" placeholder="" />
                            </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Комментарий пользователя</CCol>
                            <CCol sm="9">
                                <CInput v-model="order.customer_comment" placeholder="" />
                            </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Промокод</CCol>
                        <CCol sm="9">
                            <div class="component-cart__promocode">
                                <div class="component-cart__promocode__input input " :class="{'input-success': formPromocode.success, 'input-with-errors': formPromocode.error}">
                                <input
                                    ref="promocode"
                                    type="text"
                                    class="input_field"
                                    placeholder="Введите промокод"
                                    :value="formPromocode.value"
                                    @input="promocodeChange($event.target.value)" />
                                <button
                                    v-if="formPromocode.success"
                                    type="button"
                                    class="component-cart__promocode__button__true"
                                    @click.stop.prevent="promocodeCancel">Отменить</button>
                                <button
                                    v-else-if="formPromocode.error"
                                    type="button"
                                    class="component-cart__promocode__button__false"
                                    @click.stop.prevent="promocodeCancel"></button>
                                <button
                                    v-else  
                                    type="button"
                                    class="component-cart__promocode__button"
                                    :disabled="formPromocode.loading || !formPromocode.value"
                                    @click.stop.prevent="promocodeCheck">Применить</button>
                                </div>
                                <div
                                v-if="formPromocode.description"
                                class="component-cart__promocode__description"
                                   v-html="formPromocode.description"></div>
                                <div
                                v-if="formPromocode.error"
                                class="component-cart__promocode__error"
                                   v-html="formPromocode.error"></div>
                        </div>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Стоимость доставки</CCol>
                        <CCol sm="9">
                            <CInput v-model="order.delivery_price" placeholder="Стоимость доставки" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Стоимость</CCol>
                        <CCol sm="9">
                            <CInput v-model="order.price" placeholder="Сумма заказа" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol
                            tag="label"
                            sm="3"
                            class="col-form-label">Старая стоимость</CCol>
                        <CCol sm="9">
                            <CInput v-model="order.old_price" placeholder="Сумма заказа (до скидки)" />
                        </CCol>
                    </CRow>
                </CForm>
            </div>
            <div slot="footer">
                <CButton
                    color="primary"
                    class="mr-3"
                    @click="saveOrder"
                >Сохранить</CButton
                >
                <CButton color="light" @click="$emit('cancel')">Отмена</CButton>
            </div>
        </template>
    </CModal>
</template>

<script>

    import Vue from 'vue';
    import moment from 'moment';

    const { ORDER_STATUS, DELIVERY_TYPE } = require('../../utils/order');
    const {
        orderStatusTitle,
    } = require('../../utils/order-views');

    export default {
        name: 'OrderDetailsEdit',

        props: {
            order: {
                type: Object,
                default: () => ({}),
            },
            modal: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                isAuthorized: false,
                statuses: null,
                towers: null,
                delivery_types: null,
                promocodes: null,

                partner: null,
                goods: null,
                formPromocode: {
                    value: '',
                    success: false,
                    description: '',
                    error: '',
                    loading: false,
                },
                promocode: {},
                newOrder: {},
            };
        },

        computed: {
            adminOnly() {
                return JSON.parse(localStorage.getItem('settings'))?.is_business_admin;
            },
        },

        watch: {
            order: async function(val) {
                if(this.order.delivery_time) {
                    this.order.delivery_time = moment(new Date(this.order.delivery_time)).format('YYYY-MM-DD HH:mm:ss');
                }
                if(this.order.time_cooking) {
                    this.order.time_cooking = moment(new Date(this.order.time_cooking)).format('YYYY-MM-DD HH:mm:ss');
                }
                this.order.delivery_now = this.order.delivery_now ? true : false;
            }
        },

        async mounted() {
            if (!this.towers) {
                const towers = [{ value: null, label: 'Выберите...' }];
                (await Vue.axios.get('/address')).data.forEach(tower => {
                    towers.push({ value: tower.id, label: tower.name });
                });
                this.towers = towers;
            }
            if(!this.delivery_types) {
                const types = [];
                types.push({ value: DELIVERY_TYPE.DOOR, label: 'До двери' });
                types.push({ value: DELIVERY_TYPE.MEETING_POINT, label: 'Место встречи' });
                types.push({ value: DELIVERY_TYPE.WITHOUT, label: 'Без доставки' });
                types.push({ value: DELIVERY_TYPE.COLLECT, label: 'Сборка заказа' });
                this.delivery_types = types;
            }
            if (this.order?.promocode_id) {
                const { data } = await Vue.axios.get(`/promocodes/${this.order.promocode_id}`);
                this.formPromocode = {
                    value: data.code,
                    success: true,
                    description: data.description,
                    error: '',
                    loading: false,
                };
            } 
            if (!this.statuses) {
                const statuses = [];

                Object.values(ORDER_STATUS).forEach(status => {
                    if(this.order.delivery_type !== 2 && status == 24) {
                        return;
                    }
                
                    if (this.adminOnly && status === ORDER_STATUS.CANCELED) {
                        return;
                    }

                    if (this?.order?.ed?.items?.length) {
                        statuses.push({
                            value: status,
                            label: orderStatusTitle(status, this.order.type, this.order.payment_type, this?.order?.ed?.items[0]?.entity?.statuses, this.order.delivery_type)
                        })
                        return;
                    }
                    statuses.push({ value: status, label: orderStatusTitle(status, this.order.type, this.order.payment_type, null, this.order.delivery_type) })
                });
                this.statuses = statuses;
            }
        },

        methods: {
            promocodeCancel() {
                this.formPromocode = {
                    value: '',
                    success: false,
                    description: '',
                    error: '',
                    loading: false,
                };
            },
            async promocodeChange(value) {
                this.formPromocode.value = value;
                this.formPromocode.success = false;
                this.formPromocode.description = '';
                this.formPromocode.error = '';
            },
            async promocodeCheck() {
                if(this.formPromocode.value) {
                
                    this.formPromocode.loading = true;

                    try {
                        if (this.order && this.order.type) {
                            this.formPromocode.description = '';
                            this.formPromocode.error = '';

                            const newOrder = {
                                ...this.order,
                                promocode: this.formPromocode.value.trim(),
                                update_promocode: true,
                            };
                            const { data } = await Vue.axios.post('/orders/validate-promocode', newOrder);
                            const response = data;

                            if (response.promocode && response.promocode.message && response.order) {
                                this.formPromocode.success = true;
                                this.formPromocode.description = response.promocode.message;
                                const updatedOrder = response.order;
                                const newPromocode = await Vue.axios.get(`/promocode/code`, {params : { code: this.formPromocode.value }} );
                                if (newPromocode) {
                                    updatedOrder.promocode = newPromocode.data;
                                }
                                this.$emit('update-promocode', updatedOrder);
                                return true;

                            } else if (response.promocode && response.promocode.error) {
                                this.formPromocode.success = false;
                                this.formPromocode.error = response.promocode.error;
                            } else if (response.error) {
                                this.formPromocode.success = false;
                            } else {
                                this.formPromocode.success = false;
                                this.formPromocode.error = 'Промокод не может быть применен';
                            }
                        }
                    } finally {
                        this.formPromocode.loading = false;
                    }
                }
                return false;
            },
            async saveOrder() {
                const promocode = this.formPromocode.value ? this.formPromocode.value.trim() : '';

                if (promocode && !this.formPromocode.success) {
                    const isPromocodeApplied = await this.promocodeCheck();
                    if (!isPromocodeApplied) {
                        return;
                    }
                }

                this.$emit('update');
            },
        },
    };
</script>

<style lang="scss">
.input_field {
    outline: none;
}
@media (min-width: 850px) {
    .modal-dialog {
        max-width: 800px;
    }
}
.component-cart__promocode {
    z-index: 99;

    &__input {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        border: 1px solid #d8dbe0;
        z-index: 99;
        padding: 10px;

        > input:focus-within {
            // border: 1px solid #90949A;
        }
        > input.input-focused {
            border: none;
        }

        &.input.input-focused {
            // border: 1px solid #90949A;
        }
        &.input.input-success {
            border: 1px solid #219653;
        }
        &.input.input-with-errors {
            border: 1px solid #EB5757;
        }
    }
    &__button {
        text-align: right;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        color: #219653;

        &:disabled {
            color: #C3C8CC;
            opacity: 1;
        }

        &__true {
            color: #738FA1;
            width: auto;
            // width: 16px;
            // height: 16px;
            // background: url('../../static/cart_promocode-true.svg') center center no-repeat;
        }
        &__false {
            width: 16px;
            height: 16px;
        }
    }
    &__description {
        padding-left: 5px;
        // margin-top: -15px;
        margin-bottom: 16px;
        
        font-weight: 400;
        font-size: 12px;
        line-height: 140%;
        color: #219653;
    }
    &__error {
        padding-left: 5px;
        // margin-top: -15px;
        margin-bottom: 16px;
        
        font-weight: 400;
        font-size: 12px;
        line-height: 140%;
        color: #EB5757;
    }
}
</style>
